/* istanbul ignore file */
import React from 'react'
import { Provider } from 'react-redux';
import { getStore } from './state/store';

interface RootProviderParams {
    children: string | JSX.Element | JSX.Element[]; 
    initialStore?: any
}

const RootProvider:React.FC<RootProviderParams> = function({children,initialStore={}}) {

    const store = getStore(initialStore);
    return (
    <Provider store={store}>
        {children}
    </Provider>
    )
    
}

export default RootProvider;

